import React from "react";
import { Gift, MessageCircle, ArrowUpRight } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from "./ui/dialog";
import { formatUSD } from "../mock";
import { REWARDS_DISCORD_URL } from "../content/rewards";

export const RewardClaimDialog = ({ tier, open, onOpenChange, triggerRef }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid="wager-claim-dialog"
      className="w-[calc(100%_-_2rem)] max-w-md rounded-2xl glass p-6 sm:p-8 text-white border-emerald-500/20"
      onCloseAutoFocus={(event) => {
        if (triggerRef.current?.isConnected && !triggerRef.current.disabled) {
          event.preventDefault();
          triggerRef.current.focus();
        }
      }}
    >
      <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-500/15 ring-1 ring-emerald-400/25 text-emerald-300" aria-hidden="true"><Gift className="h-6 w-6" /></span>
      <DialogHeader className="text-left gap-2">
        <DialogTitle data-testid="wager-claim-dialog-title" className="font-display text-lg font-bold leading-snug">Claim your level-up bonus</DialogTitle>
        <DialogDescription data-testid="wager-claim-instructions" className="text-sm leading-relaxed text-slate-300">
          To claim your level-up bonus, join our Discord and create a ticket to claim your reward.
        </DialogDescription>
      </DialogHeader>
      {tier && <p data-testid="wager-claim-selected-reward" className="border-y border-white/10 py-3 text-sm text-slate-400">{tier.rank}<span className="mx-2" aria-hidden="true">·</span><span className="font-semibold text-emerald-300">{formatUSD(tier.reward)} reward</span></p>}
      <DialogFooter className="gap-2 sm:gap-0">
        <DialogClose asChild>
          <Button variant="outline" data-testid="wager-claim-dismiss" className="border-white/15 bg-white/5 hover:bg-white/10 hover:text-white text-slate-300">Close</Button>
        </DialogClose>
        <Button asChild className="bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-semibold">
          <a data-testid="wager-claim-discord" href={REWARDS_DISCORD_URL} target="_blank" rel="noopener noreferrer"><MessageCircle className="h-4 w-4" />Join Discord<ArrowUpRight className="h-4 w-4" /></a>
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);